import {
  TOGGLE_SETTINGS_MODAL,
} from './actions';


const initialState = {
    open: false
};

export default function settingsModalReducer(state = initialState, action) {
  if (action.type === TOGGLE_SETTINGS_MODAL) {
    return {
      ...state,
      open: !state.open,
    };
  }
  return state;
}
